//Import Vendor files
import 'vendor-css/bootstrap.css';
import 'vendor-css/bootstrap-datepicker.css';
import 'vendor-css/ion-range-slider.css';

//Import SASS files
import 'owl.carousel2/dist/owl.carousel.min.js';
import '../sass/app-desktop.scss';
require('es6-shim');

//Import JS files
import './home-desktop';
import './search-desktop';
import './app-desktop';
import './slick-desktop';
import './search-desktop';
import './list-desktop';
import './header';
import 'common-js/add-to-cart';
import 'common-js/common';
import 'common-js/rating-review';
import 'common-js/notification-popup';
import 'common-js/subscribe';
import 'common-js/lazy-loading';
import 'common-js/confirmation';
import 'common-js/form-validation';
import 'common-js/cart-abandonment-popup';
import 'common-js/render-recently-view';